import { render, staticRenderFns } from "./common-logList.vue?vue&type=template&id=1beb7a0b&scoped=true"
import script from "./common-logList.vue?vue&type=script&lang=js"
export * from "./common-logList.vue?vue&type=script&lang=js"
import style0 from "./common-logList.vue?vue&type=style&index=0&id=1beb7a0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb7a0b",
  null
  
)

export default component.exports